import { assignRemoteId } from 'serviceWorker/db/documents';
import { broadcastUpdatedDocument } from 'serviceWorker/broadcasts/documents';

export type AddRemoteIdToDocument = (localId: number, remoteId: string) => Promise<number>;

/** Stores the server id of the document and broadcasts the document update. */
export const addRemoteIdToDocument: AddRemoteIdToDocument =
  async function _addRemoteIdToDocument(
    localId: number,
    remoteId: string
  ): Promise<number> {
    await assignRemoteId(localId, remoteId);
    broadcastUpdatedDocument(localId);
    return localId;
  };
